import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';

export function useBlockedIpCheck() {
  const [isBlocked, setIsBlocked] = useState(false);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    const checkIpBlock = async () => {
      try {
        // Get user's IP from a public API
        const response = await fetch('https://api.ipify.org?format=json');
        const data = await response.json();
        const userIp = data.ip;

        if (userIp) {
          // Check if IP is blocked
          const { data: blockedIp } = await supabase
            .from('blocked_ips')
            .select('id')
            .eq('ip_address', userIp)
            .maybeSingle();

          if (blockedIp) {
            setIsBlocked(true);
          }
        }
      } catch (error) {
        console.error('Error checking IP block:', error);
      } finally {
        setIsChecking(false);
      }
    };

    checkIpBlock();
  }, []);

  return { isBlocked, isChecking };
}
